import React, { useEffect, useState } from "react";
import { Button, Grid, Hidden, Tooltip, Typography, Link } from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Menu from "@material-ui/core/Menu";
import { MenuItem } from "@material-ui/core";
import { store } from "../../../../helpers/store";
import moment from "moment";
import { saveAs } from "file-saver";
import { useSelector } from "react-redux";
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import {energyconsumptionService} from "../e_service/e_service"
import {usageService} from "../../../../services/usage.service"
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import Slide from '@material-ui/core/Slide';
import { useTranslation } from "react-i18next";
import {Skeleton} from '@material-ui/lab';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { getAssetUrl } from "../../../e_home_component/e_account_summary/model/service"; 
import { config } from "../../../../enviroment";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const StyledMenu = withStyles({
    paper: {
        border: "1px solid #d3d4d5",
    },
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "center",
        }}
        {...props}
        
    />
));

const useStyles = makeStyles((theme) => ({
    fixWidthMenuItem: {
        width: "100%",
        color:  theme.palette.eDark?.base+" !important",
    },
    fixBottomPadding: {
        paddingBottom: 1,
        color:  theme.palette.eDark?.base+" !important",
    },
    customWidth: {
        maxWidth: 240,
        fontSize: "0.7rem !important",
        background: theme.palette.eWhite?.base,
        color: theme.palette.ePrimary?.base
    },
    mail: {
        color: theme.palette.primary.main
    },
    ipadMail: {
        marginTop: 10,
        marginRight: 5,
        marginBottom:10
    },
    snackbarStyle: {
        [theme.breakpoints.between('sm','lg')]: {
            top: "15%"
        },
        [theme.breakpoints.only('xs')]: {
            top: "18%"
        }
        
    }
}));

const BootstrapButton = withStyles((theme) => ({
    root: {
        boxShadow: 'none !important',
        textTransform: 'none !important',
        width: 100,
        height:0.7,
        // backgroundColor: theme.palette.tertiary.main,
        '&:hover': {
            boxShadow: 'none',
        },
        '&:active': {
            boxShadow: 'none !important',
        },
        '&:focus': {
            boxShadow: 'none !important',
        },
    },
}))(Button);

export const DownloadReports = (data) => {
    const PROCESSED = "PROCESSED";
    const NOT_FOUND = "NOT_FOUND";
    const ERROR = "ERROR";
    const [noData,setNoData]=useState(false)
    const [sendMailDisable,setSendMailDisable]=useState(false)
    const Excel = require('exceljs')
    const [anchorEl, setAnchorEl] = useState(null);
    const [emailDeliveryStatus, setEmailDeliveryStatus] = useState(null);
    const [emailStatusIntervalId, setEmailStatusIntervalId] = useState(null);
    const [emailDeliverAlertOpen, setEmailDeliverAlertOpen] = useState(false);
    const [donStartDate,setdonStartDate]=useState();
    const [donEndDate,setdonEndDate]=useState();
    const { t: content1 , ready: contentReady1} = useTranslation("content-DOCUMENT_GENERATION_CONTENTS");
    const [hourlyMailModeLast24Hours, setHourlyMailModeLast24Hours] = useState("USAGE_MODE_HOURLY_LAST_24_HRS")
    const meterDetails = store?.getState()?.meterDetails
    let profileDetails = JSON.parse(localStorage.getItem("bearer"));
    let bearer = localStorage.getItem("bearer");
    const TIMESTAMP_DATE_FOMRAT = useSelector(
        (state) => state?.parametersWidgets?.ParameterLookup?.TIMESTAMP_DATE_FORMAT
    );
    const MONTH_DAY_YEAR_FORMATE = useSelector(
        (state) => state?.parametersWidgets?.ParameterLookup?.E_MONTHDAYYEAR
    );
    const {accountId} = useSelector((state) => state.meterDetails)
    const {customerNumber} = useSelector((state) => state.meterDetails)
    const languageCode = useSelector(
        (state) => state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
      );
      let  accessToken;
      let userName;
    if(bearer){
      accessToken = (JSON.parse(bearer)).acessToken;
      userName=(JSON.parse(bearer)).userName;
    }
    useEffect(()=>{
        if(data?.startDate){
            setdonStartDate(moment(data?.startDate,"YYYY-MM-DD").format(MONTH_DAY_YEAR_FORMATE))
        }else if(data?.customstartDate){
            setdonStartDate(moment(data?.customstartDate,"YYYY-MM-DD").format(MONTH_DAY_YEAR_FORMATE))
        }
         if (data?.endDate){
            setdonEndDate(moment(data?.endDate,"YYYY-MM-DD").format(MONTH_DAY_YEAR_FORMATE))
        }else if(data?.customendDate){
            setdonEndDate(moment(data?.customendDate,"YYYY-MM-DD").format(MONTH_DAY_YEAR_FORMATE))
        }
    },[data])
    const classes = useStyles()
    const {t: labels, ready: usageReportLabelReady} = useTranslation("label-E_USAGE_REPORT");
    const {t:accountDetailsLabels, ready: accountDetailLabelReady} = useTranslation("label-ACCOUNT_DETAILS");
    const personLabel = accountDetailLabelReady ? accountDetailsLabels("DASHBOARD_TITLE2_ACCOUNT_NAME") : '';
    console.log(accountDetailsLabels,"accountDetailsLabels----------152")
    const primaryIdentifier = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.PRIMARY_IDENTIFIER);
    const alertTimeout = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.E_USAGE_MAIL_ALERT_TIMEOUT);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const {t:label, ready: customerNoLabelReady} = useTranslation("label-NESCO_Customer_No_label")

    const {t: droplabel, ready: dropLabelReady} = useTranslation("label-E_USAGE_TREND"); 
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSnackbarClose = () => {
        setEmailDeliverAlertOpen(false);
        setEmailDeliveryStatus(null);
    }
    
    const getMeterNumber = () => {
        if (Array.isArray(meterDetails?.accountPersonDetail?.accountPremiseDetailList)) {
            if (Array.isArray(meterDetails?.accountPersonDetail?.accountPremiseDetailList[0]?.meterDetailsList)) {
                return meterDetails?.accountPersonDetail?.accountPremiseDetailList[0]?.meterDetailsList[0]?.meterId
            } else {
                return meterDetails?.accountPersonDetail?.accountPremiseDetailList[0]?.meterDetailsList?.meterId
            }
        } else {
            if (Array.isArray(meterDetails?.accountPersonDetail?.accountPremiseDetailList?.meterDetailsList)) {
                return meterDetails?.accountPersonDetail?.accountPremiseDetailList?.meterDetailsList[0]?.meterId
            } else {
                return meterDetails?.accountPersonDetail?.accountPremiseDetailList?.meterDetailsList?.meterId
            }
        }
    }
    const getFileName = () => {
        let filename = `${meterDetails[primaryIdentifier]}_`

        // Add View Selection information from dropdown to filename
        // Depending on time period selected, add the date range string to filename
        switch (data?.view) {
            case droplabel("E_USAGE_DROPDOWN_DAILY_VIEW"):
                filename = filename + `${droplabel("E_DAILY_VIEW_DN")}_${moment(data?.customstartDate ? data?.customstartDate : data?.startDate).format('DD-MMM-YYYY')}-${moment(data?.customendDate ? data?.customendDate : data?.endDate).format('DD-MMM-YYYY')}`
                break
            case droplabel("E_USAGE_DROPDOWN_MONTHLY_VIEW"):
                filename = filename + `${droplabel("E_MONTHLY_VIEW_DN")}_${moment(data?.customstartDate ? data?.customstartDate : data.startDate).format('MMM-YYYY')}-${moment(data?.customendDate ? data?.customendDate : data?.endDate).format('MMM-YYYY')}`
                break
            case droplabel("E_USAGE_DROPDOWN_WEEK_VIEW"):
                filename = filename + `${droplabel("E_WEEKLY_VIEW_DN")}_${moment(data?.customstartDate ? data?.customstartDate: data.startDate).format('DD-MMM-YYYY')}-${moment(data?.customendDate ? data?.customendDate: data?.endDate).format('DD-MMM-YYYY')}`
                break
            case droplabel("E_USAGE_DROPDOWN_HOUR_VIEW"):
                filename = filename + `${droplabel("E_HOURLY_VIEW_DN")}_${moment(data?.customstartDate ? data?.customstartDate: data?.startDate).format('DD-MMM-YYYY-hh-mm A')}-${moment(data?.customstartDate ? data?.customstartDate: data?.startDate).add(24, 'hours').format('DD-MMM-YYYY-hh-mm A')}`
                break
            case droplabel("E_USAGE_DROPDOWN_BILL_VIEW"):
                filename = filename + `${droplabel("E_BILL_VIEW_DN")}_${moment(data?.customstartDate ? data?.customstartDate : data?.startDate).format('MMM-YYYY')}-${moment(data?.customendDate ? data?.customendDate : data?.endDate).format('MMM-YYYY')}`
                break
        }

        return filename
    }

    const getSheetName = () => {
        if(dropLabelReady) {
        switch (data?.view) {
            case droplabel("E_USAGE_DROPDOWN_DAILY_VIEW"):
                return labels("REPORT_SHEET_DAILY")
            case droplabel("E_USAGE_DROPDOWN_MONTHLY_VIEW"):
                return labels("E_REPORT_SHEET_MONTHLY")
            case droplabel("E_USAGE_DROPDOWN_BILL_VIEW"):
                return labels("E_REPORT_SHEET_BILL")
        }
        } else {
            return '';
        }
    }

    const getColumns = (usageData, maxTouCount) => {
        let columns = []

        if (usageData.some((item) => item.intervalDateTime) ||
            data?.billView
        ) {
            columns.push(usageReportLabelReady ? labels("E_REPORT_COLUMN_DATE") : '')
        }

        if (usageData?.some((item) => item.quantity)) {
            columns.push(usageReportLabelReady ? labels("E_REPORT_COLUMN_TOTAL_USAGE") : '')
        }

        /** Following code is to add tou values ot the excel/csv sheet */
        if (maxTouCount > 0) {
            const touUsages = (usageData?.find((item) => item.touUsages && item.touUsages.length === maxTouCount)).touUsages
            touUsages.forEach((item, index) => columns.push('Day ' + (index + 1)))
        }

        if (data?.usageUom) {          
            columns.push(usageReportLabelReady ? labels("E_REPORT_COLUMN_USAGE_UOM") : '')
        }

        if (usageData?.some((item) => item.temperature)) {
            columns.push(usageReportLabelReady ? labels("E_REPORT_COLUMN_TEMPERATURE") : '')
        }

        if (data?.temperatureUom) {
            columns.push(usageReportLabelReady ? labels("E_REPORT_COLUMN_TEMPERATURE_UOM") : '')
        }

        if (data?.billView) {
            columns.push('Amount')
            columns.push('Currency')
        }

        return columns
    }

    const addUsageData = (worksheet, usageData, maxTouCount, format) => {
        const hasDateTime = usageData?.some((item) => item.intervalDateTime)
        const hasQuantity = usageData?.some((item) => item.quantity)
        const hasTemperature = usageData?.some((item) => item.temperature)
        let rowsForPDF = [];
        let totalUsagePDF=0;
        usageData.forEach((item, index) => {
            let row = []
            if (hasDateTime) {
                if (item['intervalDateTime']) {
                    switch (data?.view) {
                        case droplabel("E_USAGE_DROPDOWN_DAILY_VIEW"):
                            row.push(item['usageDate'].length>0?moment(item['usageDate']).format('DD-MMM-YYYY'):moment(item['intervalDateTime']).format('DD-MMM-YYYY'))
                            break
                        case droplabel("E_USAGE_DROPDOWN_MONTHLY_VIEW"):
                            row.push(moment(item['intervalDateTime']).format('MMM-YYYY'))
                            break
                        case droplabel("E_USAGE_DROPDOWN_WEEK_VIEW"):
                            row.push(item['intervalName'])
                            break
                        case droplabel("E_USAGE_DROPDOWN_HOUR_VIEW"):
                            row.push(item['intervalShortName'])
                            break
                        case droplabel("E_USAGE_DROPDOWN_BILL_VIEW"):
                            row.push(moment(item['usageDate']).format('MMM-YYYY'))
                            break
                    }
                } else {
                    row.push('')
                }
            }
            if (hasQuantity) {
                item.quantity ? row.push(parseFloat(item['quantity']).toFixed(2)) : row.push('')
                totalUsagePDF = totalUsagePDF + parseFloat(item['quantity']);
            }

            /** Following code is to add tou values ot the excel/csv sheet */
            if (maxTouCount > 0) {
                if (item.touUsages) {
                    item.touUsages.forEach((usage) => row.push(usage.quantity))
                    for (let i = 0; i < (maxTouCount - item.touUsages.length); i++) {
                        row.push('NA')
                    }
                } else {
                    for (let i = 0; i < maxTouCount; i++) {
                        row.push('NA')
                    }
                }
            }
            data?.usageUom && row.push(data?.usageUom)
            hasTemperature && (item.temperature ? row.push(item.temperature) : row.push(''))
            data?.temperatureUom && row.push(data?.temperatureUom)
            if (data?.billView) {
                row.push(item.amount)
                row.push(item.currency ? item.currency : 'NA')
            }
            if(format === "CSV" || format === "XLS") {
                const dataRow = worksheet.addRow(row)
                if (index % 2 === 0) {
                    dataRow.eachCell((cell, colNumber) => {
                        cell.alignment = { horizontal: 'center' }
                        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } }
                    })
                } else {
                    dataRow.eachCell((cell, colNumber) => {
                        cell.alignment = { horizontal: 'center' }
                    })
                }
            } else if(format === "PDF") {
                let pdfRow = [{ text: "", style: "table1" }, { text: "", style: "table1" }, { text: "", style: "table1" }];
                row.forEach((cell, index) => {
                    pdfRow[index].text = cell;
                })
                rowsForPDF.push(pdfRow);
            }
        })
        if(format === "CSV" || format === "XLS"){
            let row = [];
            row.push("Total");
            row.push(totalUsagePDF.toFixed(2));
            row.push((data?.usageUom ? data?.usageUom : ""));
            const dataRow = worksheet.addRow(row)
            dataRow.eachCell((cell, colNumber) => {
                cell.alignment = { horizontal: 'center' }
            })
        }
        rowsForPDF.push([{ text: "Total", style: "table1" }, { text: totalUsagePDF.toFixed(2), style: "table1" }, { text: (data?.usageUom ? data?.usageUom : ""), style: "table1" }])
        return rowsForPDF;
    }

    const addComments = (worksheet) => {
        if (data?.view && (data?.startDate || data?.endDate || data?.customstartDate)) {
            const periodRow = [usageReportLabelReady ? labels("E_REPORT_COMMENT_PERIOD") : '']
            switch (data?.view) {
                case droplabel("E_USAGE_DROPDOWN_DAILY_VIEW"): {
                    if (data?.startDate  || data?.customstartDate) {
                        periodRow.push(moment(data?.customstartDate ? data?.customstartDate : data?.startDate).format('DD-MMM-YYYY') + ' To ' + moment(data?.customendDate ? data?.customendDate : data?.endDate).format('DD-MMM-YYYY'))
                    } else {
                        periodRow.push('NA')
                    }

                    // if(data.endDate) {
                    //     periodRow.push(moment(data.customendDate ? data.customendDate : data.endDate).format('DD-MMM-YYYY'))
                    // } else {
                    //     periodRow.push('NA')
                    // }
                    break
                }
                case droplabel("E_USAGE_DROPDOWN_MONTHLY_VIEW"): {
                    if (data?.startDate || data?.customstartDate) {
                        periodRow.push(moment(data?.customstartDate ? data?.customstartDate : data?.startDate).format('MMM-YYYY') + ' To ' + moment(data?.customendDate ? data?.customendDate : data?.endDate).format('MMM-YYYY'))
                    } else {
                        periodRow.push('NA')
                    }

                    // if(data.endDate) {
                    //     periodRow.push(moment(data.customendDate ? data.customendDate : data.endDate).format('MMM-YYYY'))
                    // } else {
                    //     periodRow.push('NA')
                    // }
                    break
                }
                case droplabel("E_USAGE_DROPDOWN_WEEK_VIEW"): {
                    if (data?.startDate || data?.customstartDate) {
                        periodRow.push(moment(data?.customstartDate ? data?.customstartDate : data?.startDate).format('DD-MMM-YYYY') + ' To ' + moment(data?.customendDate ? data?.customendDate : data?.endDate).format('DD-MMM-YYYY'))
                    } else {
                        periodRow.push('NA')
                    }
                    break
                }
                case droplabel("E_USAGE_DROPDOWN_HOUR_VIEW"): {
                    if(data?.startDate || data?.customstartDate) {
                        periodRow.push(moment(data?.customstartDate ? data?.customstartDate : data?.startDate).format('DD-MMM-YYYY-hh:mm A') + ' To ' + moment(data?.customstartDate ? data?.customstartDate : data?.startDate).add(24, 'hours').format('DD-MMM-YYYY-hh:mm A'))
                    } else {
                        periodRow.push('NA')
                    }
                    break
                }
                case droplabel("E_USAGE_DROPDOWN_BILL_VIEW"): {
                    if (data?.startDate || data?.customstartDate) {
                        periodRow.push(moment(data?.customstartDate ? data?.customstartDate : data?.startDate).format('MMM-YYYY') + ' To ' + moment(data?.customendDate ? data?.customendDate : data?.endDate).format('MMM-YYYY'))
                    } else {
                        periodRow.push('NA')
                    }

                    // if(data.endDate) {
                    //     periodRow.push(moment(data.customendDate ? data.customendDate : data.endDate).format('MMM-YYYY'))
                    // } else {
                    //     periodRow.push('NA')
                    // }
                    break
                }
            }
            const row = worksheet.addRow(periodRow)
            row.getCell(1).alignment = { horizontal: 'right' }
        }
        if (meterDetails?.accountId) {
            const row = worksheet.addRow([
                customerNoLabelReady ? label("N_CUSTOMER_NUMBER") : '',
                meterDetails[primaryIdentifier]
            ])
            row.getCell(1).alignment = { horizontal: 'right' }
        }
        const meterNumber = getMeterNumber();
        if (meterNumber) {
            const row = worksheet.addRow([
                usageReportLabelReady ? labels("E_REPORT_COMMENT_METER_NUMBER") : '',
                meterNumber
            ])
            row.getCell(1).alignment = { horizontal: 'right' }
        }
        if ( profileDetails?.accountDetails?.accountSummary?.personDetailList["C1-Person"]?.personName?.entityName) {
            console.log(personLabel,"personLabel----------------------------436")
            const row = worksheet.addRow([
                personLabel,
                `${profileDetails?.accountDetails?.accountSummary?.personDetailList["C1-Person"]?.personName?.entityName} `
            ])
            row.getCell(1).alignment = { horizontal: 'right' }
        }
        worksheet.addRow([])
    }
    const getUserDetails = () => {
        let userDetails = {};
        if (data?.view && (data?.startDate || data?.endDate || data?.customstartDate)) {
            userDetails.periodLabel = usageReportLabelReady ? labels("E_REPORT_COMMENT_PERIOD") : '';
            switch (data?.view) {
                case droplabel("E_USAGE_DROPDOWN_DAILY_VIEW"): {
                    if (data?.startDate  || data?.customstartDate) {
                        userDetails.period = moment(data?.customstartDate ? data?.customstartDate : data?.startDate).format('DD-MMM-YYYY') + ' To ' + moment(data.customendDate ? data.customendDate : data.endDate).format('DD-MMM-YYYY');
                    } else {
                        userDetails.period = 'NA';
                    }
                    break
                }
                case droplabel("E_USAGE_DROPDOWN_MONTHLY_VIEW"): {
                    if (data?.startDate || data?.customstartDate) {
                        userDetails.period = moment(data?.customstartDate ? data?.customstartDate : data?.startDate).format('MMM-YYYY') + ' To ' + moment(data?.customendDate ? data?.customendDate : data?.endDate).format('MMM-YYYY');
                    } else {
                        userDetails.period = 'NA';
                    }
                    break
                }
                case droplabel("E_USAGE_DROPDOWN_WEEK_VIEW"): {
                    if (data?.startDate || data?.customstartDate) {
                        userDetails.period = moment(data?.customstartDate ? data?.customstartDate : data?.startDate).format('DD-MMM-YYYY') + ' To ' + moment(data?.customendDate ? data?.customendDate : data?.endDate).format('DD-MMM-YYYY');
                    } else {
                        userDetails.period = 'NA';
                    }
                    break
                }
                case droplabel("E_USAGE_DROPDOWN_HOUR_VIEW"): {
                    if(data?.startDate || data?.customstartDate) {
                        userDetails.period = moment(data?.customstartDate ? data?.customstartDate : data?.startDate).format('DD-MMM-YYYY-hh:mm A') + ' To ' + moment(data?.customstartDate ? data?.customstartDate : data?.startDate).add(24, 'hours').format('DD-MMM-YYYY-hh:mm A');
                    } else {
                        userDetails.period = 'NA';
                    }
                    break
                }
                case droplabel("E_USAGE_DROPDOWN_BILL_VIEW"): {
                    if (data?.startDate || data?.customstartDate) {
                        userDetails.period = moment(data?.customstartDate ? data?.customstartDate : data?.startDate).format('MMM-YYYY') + ' To ' + moment(data?.customendDate ? data?.customendDate : data?.endDate).format('MMM-YYYY');
                    } else {
                        userDetails.period = 'NA';
                    }
                    break
                }
            }
        }
        if (meterDetails[primaryIdentifier]) {
            userDetails.primaryIdentifierLabel = customerNoLabelReady ? label("N_CUSTOMER_NUMBER") : '';
            userDetails.primaryIdentifier = meterDetails[primaryIdentifier];
        }
        const meterNumber = getMeterNumber();
        if (meterNumber) {
            userDetails.meterNumberLabel = usageReportLabelReady ? labels("E_REPORT_COMMENT_METER_NUMBER") : '';
            userDetails.meterNumber = meterNumber;
        }
        if ( profileDetails?.accountDetails?.accountSummary?.personDetailList["C1-Person"]?.personName?.entityName) {
            userDetails.nameLabel = personLabel;
            userDetails.name = `${profileDetails?.accountDetails?.accountSummary?.personDetailList["C1-Person"]?.personName?.entityName} `;
        }
        return userDetails;
    }
    const getSortedData = () => {
        // const touSorted = null
        // let sortedData = data.usageData
        // let maxTouCount = null
        /** Following code is to add tou values ot the excel/csv sheet */
        // // Check if there is a priority order to the list in which tou data is sent.
        // // If no priority attribute is sent, assume that list is already sorted.
        const touSorted = data?.usageData?.every((item) => item?.touUsages && item?.touUsages?.every((touObj) => touObj?.priority))
        let sortedData = touSorted ? [] : data?.usageData
        if (touSorted) {
            // Sort the touUsages array in ascending order based on priority
            data.usageData.forEach((item) => {
                const sortedTouUsages = [...item.touUsages].sort((a, b) => a.priority - b.priority)
                sortedData.push({
                    ...item,
                    touUsages: sortedTouUsages
                })
            })
        }

        let maxTouCount = 0
        // // Even if the recorded tou for a period is zero, the same must be relayed to the front-end.
        if (data?.view === droplabel("E_USAGE_DROPDOWN_MONTHLY_VIEW")) {
            sortedData.forEach((item) => {
                if (item?.touUsages && (item?.touUsages?.length > maxTouCount)) {
                    maxTouCount = item?.touUsages?.length
                }
            })
        }
        let BILL_CHART_DATE_FORMAT = SHORT_MONTH_TWO_DIGIT_YEAR_DATE_FORMAT;
        if (data?.billView && data?.billData) {
            const billCurrency = data?.billData.find((item) => item.label === "Bill").currency;
            const dataWithBill = [];
            data.formattedBillData.graphLabels.forEach((item, index) => {
                dataWithBill.push({
                    intervalDateTime: moment(item, BILL_CHART_DATE_FORMAT).format(YEAR_DATE_FORMAT),
                    currency: billCurrency ? billCurrency : null,
                    amount:  data?.formattedBillData?.graphQuantity[index]
                })
            })
            sortedData = dataWithBill;
        }
        return { sortedData, maxTouCount }
    }

    const downloadCsv = async () => {
        let sortData = getSortedData();
        const workbook = new Excel.Workbook();
        const worksheet = workbook.addWorksheet(getSheetName());
        worksheet.properties.defaultColWidth = 15

        // Add Heading
        let heading = worksheet.addRow([usageReportLabelReady ? labels("E_REPORT_HEADING") : '','','']);
        // Add Comments
        addComments(worksheet)

        const headerRow = worksheet.addRow(getColumns(sortData?.sortedData, sortData?.maxTouCount))
        headerRow.eachCell((cell, colNumber) => {
            cell.font = { bold: true }
            cell.border = { top: { style: 'medium' }, bottom: { style: 'medium' } }
            cell.alignment = { horizontal: 'center' }
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF6699CC' } }
        })

        // Add Table Data
        addUsageData(worksheet, sortData?.sortedData, sortData?.maxTouCount, "CSV");

        
        heading.font = { size: 16, bold: true }
        heading.alignment = { horizontal: 'center' }
        heading.height = 20

        // Download CSV
        const buffer = await workbook.csv.writeBuffer();
        const fileType = 'text/csv;charset=utf-8';
        const fileExtension = '.csv';

        const blob = new Blob([buffer], { type: fileType });

        saveAs(blob, getFileName() + fileExtension);

        handleClose()
    }

    const downloadXls = async () => {
        let sortData = getSortedData();
        const workbook = new Excel.Workbook();
        const worksheet = workbook.addWorksheet(getSheetName());
        worksheet.properties.defaultColWidth = 15
        worksheet.getColumn('A').width = 20;
        if(data?.view === droplabel("E_USAGE_DROPDOWN_WEEK_VIEW") || data?.view === droplabel("E_USAGE_DROPDOWN_HOUR_VIEW")) worksheet.getColumn('A').width = 25;

        // Add Heading
        const titleRow = worksheet.addRow([usageReportLabelReady ? labels("E_REPORT_HEADING") : ''])

        // Add Comments
        addComments(worksheet)

        // Add Table Headers
        const headerRow = worksheet.addRow(getColumns(sortData?.sortedData, sortData?.maxTouCount))
        headerRow.eachCell((cell, colNumber) => {
            cell.font = { bold: true }
            cell.border = { top: { style: 'medium' }, bottom: { style: 'medium' } }
            cell.alignment = { horizontal: 'center' }
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF6699CC' } }
        })

        // Add Table Data
        addUsageData(worksheet, sortData?.sortedData, sortData?.maxTouCount, "XLS")

        // Style heading row
        const totalCols = worksheet.columnCount
        worksheet.mergeCells(1, 1, 1, totalCols)
        titleRow.font = { size: 16, bold: true }
        titleRow.alignment = { horizontal: 'center' }
        titleRow.height = 20

        // Downloading Excel Sheet
        const buffer = await workbook.xlsx.writeBuffer();
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const fileExtension = '.xlsx';

        const blob = new Blob([buffer], { type: fileType });

        saveAs(blob, getFileName() + fileExtension);

        handleClose()
    }

    let [assetInfo, setAssetInfo] = useState();
    let logoImage = useSelector(
        (store) => store?.parametersWidgets?.ParameterLookup?.E_CLIENT_LOGO
      );

      useEffect(() => {
      if (logoImage) {
          getAssetUrl(logoImage).then((res) => setAssetInfo(res))
          .catch(err => {
            setAssetInfo(null)
          });
        }
      }, [logoImage]);

    function getBase64ImageFromURL(url) {
        return new Promise((resolve, reject) => {
          var img = new Image();
          img.setAttribute("crossOrigin", "anonymous");
          img.onload = () => {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            var dataURL = canvas.toDataURL("image/png");
            resolve(dataURL);
          };
          img.onerror = error => {
            reject(error);
          };
          img.src = url;
        });
      }
const meterNumber=getMeterNumber()

    const downloadPdf = async () => {
        usageService
        .downloadData(
          customerNumber,
          accountId,
          "USAGE_REPORT",
          "",
          "",
          userName,donStartDate,donEndDate,languageCode,"","",meterNumber,"","","","","","","","","","","","","",""
        )
        .then(
          (res) => {
            store.getState().snackbar = false;
              res.data &&
              saveAs('data:application/pdf;base64,'+res.data.data.getBase64Document,  customerNumber + "Usage Report"+ moment(new Date()).format("DD-MM-YYYY"), ".pdf")
          },
          (error) => {
            store.getState().snackbar = false;
            return (
              <div>
                {
                   <p>{contentReady1 ? content1("API_FETCH_FAILED_LOG")?.answer:""}</p>
                }
              </div>
            );
          }
        );
      
    }
    // this is code for mail to me api call and other details

let AccountID =useSelector((state) => state?.meterDetails?.accountId);
let SaId =useSelector((state) => state?.meterDetails?.getSaInfo?.saId);
let primaryID = useSelector((state) =>state?.meterDetails[primaryIdentifier]);

let emailId = "";
if (bearer) {
  bearer = JSON.parse(bearer);
  emailId = bearer.email;
}
const YEAR_DATE_FORMAT = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.YEAR_DATE_FORMAT);
const SHORT_MONTH_TWO_DIGIT_YEAR_DATE_FORMAT = useSelector((state) => state?.parametersWidgets?.ParameterLookup?.SHORT_MONTH_TWO_DIGIT_YEAR_DATE_FORMAT);
const [startDate, setStartDate] = React.useState(null);
const [endDate, setEndDate] = React.useState(null);
const [message, setMessage] = useState()
const sendMail =() =>{  
    let endDate = data?.endDate;
    let startDate = data?.startDate;
    let customstartDate = data?.customstartDate;
    let customendDate = data?.customendDate;
    let mode;
    let additionalIdentifiers;;
    if(data?.view === "USAGE_DROPDOWN_DAILY_VIEW"){
        mode ='DAILY_VIEW'
    }
    else if (data?.view === "USAGE_DROPDOWN_MONTHLY_VIEW"){
        mode = 'MONTHLY_VIEW'
    }
    else if (data?.view === "USAGE_DROPDOWN_BILL_VIEW"){
        mode = 'BILL_VIEW'
    }
    else if (data?.view === "USAGE_DROPDOWN_HOUR_VIEW"){
        mode = 'HOURLY_VIEW'
        if(data?.hourlyMode === hourlyMailModeLast24Hours && !data?.hourCustomRange) {
            additionalIdentifiers = [
                {
                name: "mode",
                value: hourlyMailModeLast24Hours
                },
                {
                name: "clientTimestamp",
                value: moment().format(TIMESTAMP_DATE_FOMRAT)
                }
            ]
        }
    }
    else if (data?.view === "USAGE_DROPDOWN_WEEK_VIEW"){
        mode = 'WEEKLY_VIEW'
    }
    setStartDate(startDate)
    setEndDate(endDate)
    setSendMailDisable(true)
    store.getState().snackbar = true;
    let meterNumber = getMeterNumber();
    let mailStartDate = moment(startDate ? startDate : customstartDate).format(YEAR_DATE_FORMAT);
    let mailEndDate = moment(endDate ? endDate : customendDate).format(YEAR_DATE_FORMAT);
    energyconsumptionService.usageMail(mailStartDate,mailEndDate,AccountID,SaId,mode,meterNumber,primaryID, additionalIdentifiers)
    .then((response) =>{
        store.getState().snackbar = false;
        setMessage('')
    })
    .catch((err) =>{
        store.getState().snackbar = false;
        setMessage("")
        setSendMailDisable(false)
    });
}

function mailDeliveryStatusApiCall() {
    energyconsumptionService.usageMailStatus(AccountID,SaId)
    .then((response) =>{
        let status = response?.data?.getEmailStatus?.status;
        setEmailDeliveryStatus(status)
    })
    .catch((err) =>{
        setEmailDeliveryStatus(ERROR)
    })
}

const getMailDeliveryStatus = () => {
    let intervalId = setInterval(() => {mailDeliveryStatusApiCall()}, 5000);
    setEmailStatusIntervalId(intervalId);
}
useEffect(() => {
    if(emailDeliveryStatus === PROCESSED || 
    emailDeliveryStatus === ERROR
    ) {
        setEmailDeliverAlertOpen(true);
       setSendMailDisable(false)
        clearTimeout(emailStatusIntervalId);
    } else if(emailDeliveryStatus === NOT_FOUND ) {
        setEmailDeliverAlertOpen(true);
       setSendMailDisable(false)
        clearTimeout(emailStatusIntervalId);
    }
}, [emailDeliveryStatus])

useEffect(()=>{
 const mdm = data && data?.usageData?.filter((item)=>item?.quantity!=='0')
 if (mdm?.length===0 || mdm === undefined){
    setNoData(true)
    setSendMailDisable(true)
 }else{
     setNoData(false)
     if(primaryIdentifier === 'customerNumber'){
      setSendMailDisable(true);
    }
    else{
      setSendMailDisable(false)
    }
 }
 if(data?.billData) {
     setNoData(false)
    setSendMailDisable(false)
 }
},[noData,data])
    return (
        <div>
            {/* this is for mobiles */}
            <Hidden smUp>
                <div>
                    <Grid container align-items= "flex-start" direction="row" >
                        {/* <Grid  item >
                            <div className={classes.ipadMail}>
                                <Tooltip
                                    classes={{ tooltip: classes.customWidth }}
                                    title={usageReportLabelReady ? labels("E_E_MAIL_TO_ME_TOOLTIP") : ''}
                                    placement='top'>
                                    <BootstrapButton
                                        aria-controls="customized-menu"
                                        aria-haspopup="true"
                                        variant="text"
                                        disableRipple="true"
                                        disabled={sendMailDisable}
                                        onClick={()=>{ 
                                            sendMail(); 
                                            getMailDeliveryStatus();
                                        }}
                                    >
                                        <MailOutlineIcon fontSize="1px"/>{usageReportLabelReady ? labels("E_E_MAIL_TO_ME"): <Skeleton />}
                                    </BootstrapButton>
                                </Tooltip>
                            </div>
                        </Grid> */}
                        <Grid item>
                            <div className={classes.ipadMail}>
                                <Tooltip
                                    classes={{ tooltip: classes.customWidth }}
                                    title={

                                        usageReportLabelReady ? labels("E_DOWNLOAD_REPORT_TOOLTIP") : ''

                                    }
                                    placement='top'
                                >
                                    <BootstrapButton
                                        aria-controls="customized-menu"
                                        aria-haspopup="true"
                                        variant="text"
                                        disableRipple="true"
                                        onClick={handleClick}
                                        disabled={noData}
                                    >
                                        
                                        <SystemUpdateAltIcon  fontSize="small"/>{usageReportLabelReady ? labels("E_DOWNLOAD_REPORT_BUTTON") : <Skeleton />}
                                    </BootstrapButton>
                                </Tooltip>
                                <StyledMenu
                                    id="customized-menu"
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={Boolean(anchorEl)}
                                    onClose={handleClose}
                                >
                                    <MenuItem className={classes.fixWidthMenuItem} onClick={downloadXls} divider>
                                        <span className={classes.fixBottomPadding}>{usageReportLabelReady ? labels("E_DONWLOAD_REPORT_XLS") : <Skeleton />}</span>
                                    </MenuItem>
                                    <MenuItem className={classes.fixWidthMenuItem} onClick={downloadCsv}>
                                        <span sclassName={classes.fixBottomPadding}>{usageReportLabelReady ? labels("E_DONWLOAD_REPORT_CSV") : <Skeleton />}</span>
                                    </MenuItem>
                                    {/* <MenuItem className={classes.fixWidthMenuItem} onClick={downloadPdf}>
                                        <span sclassName={classes.fixBottomPadding}>{usageReportLabelReady ? labels("E_DOWNLOAD_REPORT_PDF") : <Skeleton />}</span>
                                    </MenuItem> */}
                                </StyledMenu>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </Hidden>
            {/* this is for ipads */}
            <Hidden xsDown mdUp>
                <Grid container direction="row" align-items= "flex-end">
                    {/* <Grid  >
                        <div className={classes.ipadMail}>
                            <Tooltip
                                classes={{ tooltip: classes.customWidth }}
                                title={usageReportLabelReady ? labels("E_E_MAIL_TO_ME_TOOLTIP") : <Skeleton />}
                                placement='top'>
                                <BootstrapButton
                                    aria-controls="customized-menu"
                                    aria-haspopup="true"
                                    variant="text"
                                    disableRipple="true"
                                    disabled={sendMailDisable}
                                    onClick={()=>{ 
                                        sendMail();
                                        getMailDeliveryStatus();
                                    }}
                                >   
                                    <MailOutlineIcon fontSize="small" />{usageReportLabelReady ? labels("E_E_MAIL_TO_ME") : <Skeleton />}
                                </BootstrapButton></Tooltip>
                        </div>
                    </Grid> */}
                    <Grid >
                        <div className={classes.ipadMail}>
                            <Tooltip
                                classes={{ tooltip: classes.customWidth }}
                                title={

                                    usageReportLabelReady ? labels("E_DOWNLOAD_REPORT_TOOLTIP") : ''

                                }
                                placement='top'
                            >
                                <BootstrapButton
                                    aria-controls="customized-menu"
                                    aria-haspopup="true"
                                    variant="text"
                                    disableRipple="true"
                                    onClick={handleClick}
                                    disabled={(data?.view === labels("E_USAGE_DROPDOWN_HOURLY_VIEW")) || noData}
                                >
                                    
                                    <SystemUpdateAltIcon fontSize="small"/>{usageReportLabelReady ? labels("E_DOWNLOAD_REPORT_BUTTON") : <Skeleton />} 
                                </BootstrapButton>
                            </Tooltip>
                            <StyledMenu
                                id="customized-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                <MenuItem className={classes.fixWidthMenuItem} onClick={downloadXls} divider>
                                {
                                    usageReportLabelReady ?
                                    <span className={classes.fixBottomPadding}>{labels("E_DONWLOAD_REPORT_XLS")}</span>
                                    : <Skeleton/>
                                }
                                </MenuItem>
                                <MenuItem className={classes.fixWidthMenuItem} onClick={downloadCsv}>
                                {
                                    usageReportLabelReady?
                                    <span sclassName={classes.fixBottomPadding}>{labels("E_DONWLOAD_REPORT_CSV")}</span>
                                    : <Skeleton />
                                }
                                </MenuItem>
                                {/* <MenuItem className={classes.fixWidthMenuItem} onClick={downloadPdf}>
                                {
                                    usageReportLabelReady?
                                    <span sclassName={classes.fixBottomPadding}>{labels("E_DOWNLOAD_REPORT_PDF")}</span>
                                    : <Skeleton />
                                }
                                </MenuItem> */}
                            </StyledMenu>
                        </div>
                    </Grid>
                </Grid>
            </Hidden>
            {/* this is for desktop */}
            <Hidden smDown xlUp>
                <Grid container direction="row" spacing={1} align-items= "flex-end">
                    {/* <Grid >
                        <div >
                            <Tooltip
                                classes={{ tooltip: classes.customWidth }}
                                title={usageReportLabelReady ? labels("E_E_MAIL_TO_ME_TOOLTIP") : <Skeleton />}
                                placement='top'>
                                <BootstrapButton
                                    aria-controls="customized-menu"
                                    aria-haspopup="true"
                                    variant="text"
                                    disableRipple="true"
                                    disabled={sendMailDisable}
                                    onClick={()=>{ 
                                        sendMail();
                                        getMailDeliveryStatus();
                                    }}
                                >
                                    <MailOutlineIcon fontSize="small"/>{usageReportLabelReady ? labels("E_E_MAIL_TO_ME") : <Skeleton />}
                                </BootstrapButton ></Tooltip>
                        </div>
                    </Grid> */}
                    <Grid >
                        <div >
                            <Tooltip
                                classes={{ tooltip: classes.customWidth }}
                                title={usageReportLabelReady ? labels("E_DOWNLOAD_REPORT_TOOLTIP") : <Skeleton />}
                                placement='top'
                            >
                                <BootstrapButton
                                height="1px"
                                    aria-controls="customized-menu"
                                    aria-haspopup="true"
                                    variant="text"
                                    disableRipple="true"
                                    onClick={handleClick}
                                    disabled={noData}
                                >
                                   
                                    <SystemUpdateAltIcon fontSize="small" />{usageReportLabelReady ? labels("E_DOWNLOAD_REPORT_BUTTON") : <Skeleton />}
                                </BootstrapButton>
                            </Tooltip>
                            <StyledMenu
                                id="customized-menu"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                <MenuItem className={classes.fixWidthMenuItem} onClick={downloadXls} divider>
                                {
                                    usageReportLabelReady ?
                                    <span className={classes.fixBottomPadding}>{labels("E_DONWLOAD_REPORT_XLS")}</span>
                                    : <Skeleton />
                                }
                                </MenuItem>
                                <MenuItem className={classes.fixWidthMenuItem} onClick={downloadCsv}>
                                {
                                    usageReportLabelReady ?
                                    <span className={classes.fixBottomPadding}>{labels("E_DONWLOAD_REPORT_CSV")}</span>
                                    : <Skeleton />
                                }
                                </MenuItem>
                                {/* <MenuItem className={classes.fixWidthMenuItem} onClick={downloadPdf}>
                                {
                                    usageReportLabelReady ?
                                    <span className={classes.fixBottomPadding}>{labels("E_DOWNLOAD_REPORT_PDF")}</span>
                                    : <Skeleton />
                                }
                                </MenuItem> */}
                            </StyledMenu>
                        </div>
                    </Grid>
                </Grid>

            </Hidden>

    <>
        {emailDeliveryStatus === PROCESSED && 
        <Slide direction="left" in={emailDeliverAlertOpen} mountOnEnter unmountOnExit>
        <Snackbar open={emailDeliverAlertOpen} autoHideDuration={alertTimeout} 
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={handleSnackbarClose}
        className={classes.snackbarStyle}
        >
        <MuiAlert onClose={handleSnackbarClose} 
        severity="success" icon={<CheckCircleIcon fontSize="inherit" />}>
        {usageReportLabelReady ? labels('E_USAGE_EMAIL_SUCCESS')?.replace("&emailid&",emailId) : <Skeleton />} 
        </MuiAlert>
        </Snackbar>
        </Slide>
        }
    </>
    <>
        {
        emailDeliveryStatus === NOT_FOUND &&
        <Slide direction="left" in={emailDeliverAlertOpen} mountOnEnter unmountOnExit>
        <Snackbar open={emailDeliverAlertOpen} autoHideDuration={alertTimeout}
        className={classes.snackbarStyle}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={handleSnackbarClose}>
            <MuiAlert onClose={handleSnackbarClose} severity="warning"
            icon={<WarningRoundedIcon fontSize="inherit" />}>
            {usageReportLabelReady ? labels("E_USAGE_EMAIL_NOT_FOUND") : <Skeleton />}
            </MuiAlert>
        </Snackbar>
        </Slide>
        }
    </>
    <>
        {
        emailDeliveryStatus === ERROR &&
        <Slide direction="left" in={emailDeliverAlertOpen} mountOnEnter unmountOnExit>
        <Snackbar open={emailDeliverAlertOpen} autoHideDuration={alertTimeout} onClose={handleSnackbarClose} 
        className={classes.snackbarStyle}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
        <MuiAlert onClose={handleSnackbarClose} severity="error">
            {usageReportLabelReady ? labels("E_USAGE_EMAIL_ERROR") : <Skeleton />}
        </MuiAlert>
        </Snackbar>
        </Slide>
        }
    </>
        </div>
    );
}